import axios from "axios";
import headers from "./Header";
class MsService {
  getData(query) {
    return axios.get(query, {
      headers: headers(),
    });
  }

  getDataById(query, id) {
    return axios.get(query + "/" + id, {
      headers: headers(),
    });
  }

  postData(query, data) {
    return axios.post(query, data, {
      headers: headers(),
    });
  }

  putData(query, data) {
    return axios.put(query, data, {
      headers: headers(),
    });
  }

  deleteData(query, data) {
    return axios.delete(query, {
      headers: headers(),
      data: data,
    });
  }

  getPengguna() {
    return axios.get("/pengguna", {
      headers: headers(),
    });
  }

  getPegawaiByUsername(username) {
    return axios.get("/search-by-username/" + username, {
      headers: headers(),
    });
  }

  addPengguna(data) {
    return axios.post("pengguna/add", data, {
      headers: headers(),
    });
  }

  putPengguna(data) {
    return axios.put("pengguna/update", data, {
      headers: headers(),
    });
  }

  delPengguna(data) {
    return axios.delete("user/delete", {
      headers: headers(),
      data: data,
    });
  }

  getRoles(param) {
    return axios.get("/pengguna/roles" + (typeof param === "undefined" ? "" : param), {
      headers: headers(),
    });
  }

  getRolesInUser(id) {
    return axios.get("/pengguna/roles-in-user/" + id, {
      headers: headers(),
    });
  }

  getRolesNotinUser(id) {
    return axios.get("/pengguna/roles-not-in-user/" + id, {
      headers: headers(),
    });
  }

  addUserRole(data) {
    return axios.post("/pengguna/user-role/add", data, {
      headers: headers(),
    });
  }

  delUserRole(data) {
    return axios.delete("/pengguna/user-role/delete", {
      headers: headers(),
      data: data,
    });
  }

  getInstansi() {
    return axios.get("/instansi/operator", {
      headers: headers(),
    });
  }
  getMasterInstansi(){
    return axios.get("/organization", {
      headers: headers(),
    });
  }
  getInstansiList(name, provinceCode){
    let url = "/metadata-statistik/organisasi-penyelenggara";
    if(name){
      url = url + "?name="+name;
    }
    if(provinceCode){
      url = url + "&province_code="+provinceCode;
    }
    return axios.get(url, {
      headers: headers(),
    });
  }

  getEselon1(id_instansi) {
    return axios.get("/eselon1/operator?id_instansi="+id_instansi, {
      headers: headers(),
    });
  }

  getEselon2(id_eselon1, id_instansi) {
    return axios.get("/eselon2/operator?id_eselon1="+id_eselon1+"&id_instansi="+id_instansi, {
      headers: headers(),
    });
  }

  getMetadataById(id) {
    return axios.get("/sdi/metadata-kegiatan/"+id, {
      headers: headers(),
    });
  }

  getMetadataVariabelById(id) {
    return axios.get("/sdi/metadata-variabel/"+id, {
      headers: headers(),
    });
  }

  getMetadataIndikatorById(id) {
    return axios.get("/sdi/metadata-indikator/"+id, {
      headers: headers(),
    });
  }

  

  putMetadata(query, id, data) {
    return axios.put("/sdi" + query + "/" + id, data, {
      headers: headers(),
    });
  }

  getSummaryMetadata(submmissionPeriod, page) {
    return axios.get("/sdi/summary/metadata-kegiatan?submmissionPeriod="+submmissionPeriod+"&page="+page+"&size=10", {
      headers: headers(),
    });
  }

  getSummaryMetadataVariabel(id_kegiatan, page) {
    return axios.get("/sdi/metadata-statistik-kegiatan/"+id_kegiatan+"/metadata-statistik-variabel?page="+page+"&size=10", {
      headers: headers(),
    });
  }

  getSummaryMetadataIndikator(id_kegiatan, page) {
    return axios.get("/sdi/metadata-statistik-kegiatan/"+id_kegiatan+"/metadata-statistik-indikator?page="+page+"&size=10", {
      headers: headers(),
    });
  }

  getApprovalMetadata(page) {
    return axios.get("/sdi/approval/metadata-kegiatan?page="+page+"&size=10", {
      headers: headers(),
    });
  }

  getApprovalMetadataByWilayah(page, kode_wilayah) {
    return axios.get("/sdi/approval/metadata-kegiatan/by-wilayah?kode_wilayah="+kode_wilayah+"&page="+page+"&size=10", {
      headers: headers(),
    });
  }

  getMsKegApprovalList(page, name, jenisStatistik, caraPengumpulanData, status, responsibleOrganization, responsibleDivision){
    let url = "/sdi/approval/metadata-kegiatan?page="+page+"&size=10";
    if(name != null){
      url = url + "&name="+name
    }
    if(jenisStatistik != null){
      url = url + "&jenis_statistik="+jenisStatistik
    }
    if(caraPengumpulanData != null){
      url = url + "&cara_pengumpulan_data="+caraPengumpulanData
    }
    if(status != null){
      url = url + "&status="+status
    }
    if(responsibleOrganization != null){
      url = url + "&responsible_organization="+responsibleOrganization
    }
    if(responsibleDivision != null){
      url = url + "&responsible_division="+responsibleDivision
    }
    return axios.get(url, {
      headers: headers(),
    });
    
  }
  getMsKegApprovalListByRegion(page, kode_wilayah, name, jenisStatistik, caraPengumpulanData, status, responsibleOrganization, responsibleDivision){
    let url = "/sdi/approval/metadata-kegiatan/by-wilayah?page="+page+"&size=10&kode_wilayah="+kode_wilayah;
    if(name && name.trim().length){
      url = url + "&name="+name
    }
    if(status != null){
      url = url + "&status="+status
    }
    if(jenisStatistik != null){
      url = url + "&jenis_statistik="+jenisStatistik
    }
    if(caraPengumpulanData != null){
      url = url + "&cara_pengumpulan_data="+caraPengumpulanData
    }
    if(responsibleOrganization != null){
      url = url + "&responsible_organization="+responsibleOrganization
    }
    if(responsibleDivision != null){
      url = url + "&responsible_division="+responsibleDivision
    }
    return axios.get(url, {
      headers: headers(),
    });
  }

  delMetadata(type, id) {
    return axios.delete("/sdi/"+type+"/" + id, {
      headers: headers(),
    });
  }

  getDashboard(query) {
    return axios.get("/sdi/dashboard/" + query, {
      headers: headers(),
    });
  }

  getPeriodePengajuanMs() {
    return axios.get("/sdi/periode-pengajuan-metadata", {
      headers: headers(),
    });
  }
  
  postMetadata(query, data) {
    return axios.post("/sdi"+query, data, {
      headers: headers(),
    });
  }

  // New MS Keg
  saveNewMsKeg(data){
    return axios.post("/sdi/v2/metadata-statistik/kegiatan", data, {
      headers: headers(),
    });
  }
  updateMsKeg(data,id){
    return axios.put("/sdi/v2/metadata-statistik/kegiatan/"+id, data, {
      headers: headers(),
    });
  }
  getMsKegList(filterQuery){
    let url = "/sdi/v2/metadata-statistik/kegiatan?"
    if(filterQuery != null){
      url += filterQuery;
    }
    return axios.get(url, {
      headers: headers(),
    });
  }
  getMsKegById(id){
    let url = "/sdi/v2/metadata-statistik/kegiatan/"+id
    return axios.get(url, {
      headers: headers(),
    });
  }
  deleteMsKegById(id){
    let url = "/sdi/v2/metadata-statistik/kegiatan/"+id
    return axios.delete(url, {
      headers: headers(),
    });
  }
  // New MS Var
  saveNewMsVar(data){
    return axios.post("/sdi/v2/metadata-statistik/variabel", data, {
      headers: headers(),
    });
  }
  updateMsVar(data,id){
    return axios.put("/sdi/v2/metadata-statistik/variabel/"+id, data, {
      headers: headers(),
    });
  }
  getMsVarById(id){
    let url = "/sdi/v2/metadata-statistik/variabel/"+id
    return axios.get(url, {
      headers: headers(),
    });
  }
  deleteMsVargById(id){
    let url = "/sdi/v2/metadata-statistik/variabel/"+id
    return axios.delete(url, {
      headers: headers(),
    });
  }
  getMsVarList(filterQuery){
    let url = "/sdi/v2/metadata-statistik/variabel?"
    if(filterQuery != null){
      url += filterQuery;
    }
    return axios.get(url, {
      headers: headers(),
    });
  }
  // New MS Ind
  saveNewMsInd(data){
    return axios.post("/sdi/v2/metadata-statistik/indikator", data, {
      headers: headers(),
    });
  }
  updateMsInd(data,id){
    return axios.put("/sdi/v2/metadata-statistik/indikator/"+id, data, {
      headers: headers(),
    });
  }
  getMsIndById(id){
    let url = "/sdi/v2/metadata-statistik/indikator/"+id
    return axios.get(url, {
      headers: headers(),
    });
  }
  deleteMsIndById(id){
    let url = "/sdi/v2/metadata-statistik/indikator/"+id
    return axios.delete(url, {
      headers: headers(),
    });
  }
  getMsIndList(filterQuery){
    let url = "/sdi/v2/metadata-statistik/indikator?"
    if(filterQuery != null){
      url += filterQuery;
    }
    return axios.get(url, {
      headers: headers(),
    });
  }

  getProdusenDataSummary(submissionPeriod, produsenDataId){
    let url = "/metadata-statistik/produsen-data-summary?"
    if(submissionPeriod){
      url = url + "submissionPeriod="+submissionPeriod+"&"
    }
    if(produsenDataId){
      url = url + "produsenDataId="+produsenDataId
    }
    return axios.get(url, {
      headers: headers(),
    });
  }

  getProdusenDataSummaryByStatus(submissionPeriod, produsenDataId){
    let url = "/metadata-statistik/produsen-data-summary-by-status?"
    if(submissionPeriod){
      url = url + "submissionPeriod="+submissionPeriod+"&"
    }
    if(produsenDataId){
      url = url + "produsenDataId="+produsenDataId
    }
    return axios.get(url, {
      headers: headers(),
    });
  }


  

}

export default new MsService();
